export const localValidate = (formState) => {
  let errors = {};
  
  return errors;
};

const SelectionsAdminToolValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default SelectionsAdminToolValidation;